import React from "react";
import loadable from '@loadable/component'
import ReactDOM from "react-dom";
import { BrowserRouter } from 'react-router-dom';
import "./index.css";
const App = loadable(() => import('./App'))

ReactDOM.render(
  <BrowserRouter>
    <div className="app">
      <App />
    </div>
  </BrowserRouter>,
  document.getElementById("root")
);
